import React from "react";
import { Button, Col, Container, Modal, Row, Spinner,  } from "react-bootstrap";
import  FileViewer  from "react-file-viewer";
import { Heading } from "rsuite";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import { Box, Text, useColorModeValue,Tooltip } from "@chakra-ui/react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
function ResumePreviewModal({
  preview,
  handlePreviewClose,
  objectURL,
  action,
  resumeFilePath,
  firstName,
  lastName,
  phone,
  email,
  fileName,
  submitBtn,
  submitAction
}) {
  return (
    <div>
      <div className="model-box-view">
        <Modal
          show={preview}
          onHide={handlePreviewClose}
          backdrop="static"
          keyboard={false}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title className="usertitle">Resume Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={8} md={6} sm={6}>
                  {!objectURL ? (
                    <>
                      <div className="resume_ld">
                        <Spinner />
                      </div>
                    </>
                  ) : objectURL === "no-resume" ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img
                        src={NotFound}
                        alt="NotFound"
                        style={{ width: "16rem" }}
                      />
                      <p>No Resume Found! Please try again....</p>
                    </div>
                  ) : (
                    <div
                      style={{
                        borderRight: "1px solid rgb(222, 226, 230)",
                        paddingRight: "18px",
                      }}
                    >
                      {(() => {
                        const isObjectUrlDoc =
                          objectURL &&
                          (objectURL.toLowerCase().endsWith(".doc") ||
                            objectURL.toLowerCase().endsWith(".docx"));
                        if (isObjectUrlDoc) {
                          const filePath = objectURL
                            ? `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL}`
                            : resumeFilePath;

                          return (
                            <>
                              <Box
                                style={{
                                  overflow: "auto",
                                  userSelect: "text",
                                  height: "85vh",
                                  position: "relative",
                                }}
                              >
                                <FileViewer
                                  fileType={
                                    objectURL.toLowerCase().endsWith(".doc")
                                      ? "doc"
                                      : "docx"
                                  }
                                  filePath={filePath}
                                  onError={(e) => {
                                    console.error("FileViewer Error:", e);
                                    // setViewerError(e);
                                  }}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                  }}
                                />
                              </Box>
                            </>
                          );
                        }

                        // Use iframe for other file types
                        return (
                          <>
                            {objectURL && (
                              <iframe
                                src={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL}`}
                                width="100%"
                                height="800px"
                                title="PDF Viewer"
                                frameBorder="0"
                                style={{ border: "none" }}
                              />
                            )}
                          </>
                        );
                      })()}
                    </div>
                  )}
                </Col>
                <Col lg={4} md={6} sm={6}>
                  <div className="resume_pr">
                    <div>
                      <div>
                        {submitBtn && (
                          <Button
                            style={{
                              color: "white",
                              border: "1px solid #d7d7d7",
                              fontWeight: "500",
                              letterSpacing: "1px",
                              fontSize: "14px",
                            }}
                            className="bg_color"
                            onClick={submitAction}
                          >
                            Submit Job
                          </Button>
                        )}
                        <Button
                          className="bg_color"
                          style={{
                            color: "white",
                            border: "1px solid #d7d7d7",
                            fontWeight: "500",
                            letterSpacing: "1px",
                            fontSize: "14px",
                          }}
                          onClick={action}
                        >
                          Notes
                        </Button>
                      </div>

                      <Heading
                        size="md"
                        fontWeight="bold"
                        letterSpacing="tight"
                      >
                        {!firstName ? "N/A" : firstName}{" "}
                        {!lastName ? "N/A" : lastName}
                      </Heading>
                      <Text color={useColorModeValue("gray.600", "gray.400")}>
                        <CallOutlinedIcon style={{ fontSize: "medium" }} />{" "}
                        {!phone ? "N/A" : phone}
                      </Text>
                      <Text color={useColorModeValue("gray.600", "gray.400")}>
                        <MailOutlineIcon style={{ fontSize: "medium" }} />{" "}
                        {!email ? "N/A" : email}
                      </Text>
                    </div>
                    <div>
                      <Tooltip
                        hasArrow
                        label="Download Resume"
                        bg="gray.300"
                        color="black"
                      >
                        <a
                          href={
                            objectURL === "no-resume"
                              ? "#"
                              : `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL}`
                          }
                          download={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL}`}
                          onClick={(e) => {
                            if (objectURL.toLowerCase().endsWith(".pdf")) {
                              e.preventDefault();
                              fetch(
                                `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL}`
                              )
                                .then((response) => response.blob())
                                .then((blob) => {
                                  const url = window.URL.createObjectURL(blob);
                                  const link = document.createElement("a");
                                  link.href = url;
                                  link.download =
                                    objectURL?.split("/").pop() ||
                                    "download.pdf";
                                  document.body.appendChild(link);
                                  link.click();
                                  link.remove();
                                  window.URL.revokeObjectURL(url);
                                });
                            }
                          }}
                          rel="noopener noreferrer"
                        >
                          <button
                            class="btn bg-white border rounded mb-2 text-break"
                            style={{ width: "100%", height: "auto" }}
                          >
                            {!fileName ? "N/A" : fileName}{" "}
                        
                            <VerticalAlignBottomIcon
                              style={{ color: "grey" }}
                            />
                          </button>
                        </a>
                      </Tooltip>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
            <Button className="cancel" onClick={handlePreviewClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default ResumePreviewModal;
